import { Injectable } from '@angular/core';
import {UrlParamsService} from '../../core/services/impl/url-params.service';
import {env, salesChannel} from '../../core/utils/utils';
import {SalesChannel} from '../../core/consts/sales-channel.enum';
import {ResourcesConfig, ResourcesEndpointConfig} from '../../core/configs/resources-config';

@Injectable()
export class ResourceService {

  resourcesEndpoint: string;
  configResourcesEndpoint: string;
  private readonly SKYCASH_PDF_DEEP_LINK_PREFIX = 'skycash://mars.skycash.com/tags/show?id=pdf:viewer:byUrl:';
  private readonly DEEP_LINKS_MECHANISM_DISABLED = false;
  private resourcesConfig: ResourcesConfig;

  get customResourceEndpointsConfig(): ResourcesEndpointConfig | null {
    if (this.resourcesConfig.customResourceEndpoints) {
      return this.resourcesConfig.customResourceEndpoints.find(config => config.salesChannel === salesChannel());
    }
    return null;
  }

  get isResourceEndpointCustom(): boolean {
    return this.configResourcesEndpoint !== this.resourcesEndpoint;
  }

  constructor(private urlParamsService: UrlParamsService) {
  }

  init(configResourcesEndpoint: string, config: ResourcesConfig): void {
    this.resourcesConfig = config;
    this.configResourcesEndpoint = configResourcesEndpoint;
    this.resourcesEndpoint = this.getResourceEndpoint();
  }

  buildResourceUrlFromKey(key: string): string | null {
    const resource = this.resourcesConfig.resources.find(resourceConfig => resourceConfig.key === key);
    return resource ? this.buildResourceURL(resource.uriSuffix) : null;
  }

  buildResourceURL(resourceUriSuffix: string): string | null {
    if (resourceUriSuffix) {
      let prefix = this.resourcesEndpoint;
      return prefix + '/' + resourceUriSuffix;
    } else {
      return null;
    }
  }

  updatePdfLinks(): void {
    if (this.urlParamsService.isMobileOrigin && !this.DEEP_LINKS_MECHANISM_DISABLED) {
      Array.from(document.querySelectorAll('a'))
          .forEach(el => {
            if (!!el.href && el.href.toLowerCase().endsWith('.pdf')) {
              el.href = this.getModifiedPdfUrl(el.href);
            }
          });
    }
  }

  private getResourceEndpoint(): string {
    if (this.customResourceEndpointsConfig && !!this.customResourceEndpointsConfig.endpoints) {
      const envEndpoint = this.customResourceEndpointsConfig.endpoints.find(endpointConfig => endpointConfig.env === env());
      return envEndpoint ? envEndpoint.endpoint : this.configResourcesEndpoint;
    }
    return this.configResourcesEndpoint;
  }

  private getModifiedPdfUrl(originalUrl: string): string {
    switch (salesChannel()) {
      case SalesChannel.SKYCASH:
        if (!originalUrl.includes(this.SKYCASH_PDF_DEEP_LINK_PREFIX)) {
          return `${this.SKYCASH_PDF_DEEP_LINK_PREFIX}${originalUrl}`;
        }
        return originalUrl;
      default:
        return originalUrl;
    }
  }
}
